
  export const Fruits = [
    {id: "cle", article: "une", name: "clémentine", emoji: "🍊"},
    {id: "man", article: "une", name: "mandarine", emoji: "🍊"},
    {id: "ora", article: "une", name: "orange", emoji: "🍊"},
    {id: "cit", article: "un", name: "citron", emoji: "🍋"},
    {id: "civ", article: "un", name: "citron vert", emoji: ""},
    {id: "par", article: "un", name: "pamplemousse rose", emoji: ""},
    {id: "paj", article: "un", name: "pamplemousse jaune", emoji: ""},
  ];

  export const Locations = [
    {id: "spa", flag: "🇪🇸", name: "Espagne"},
    {id: "fra", flag: "🇫🇷", name: "France Métropolitaine"},
    {id: "frc", flag: "🇫🇷", name: "France, Corse"}
  ]